import { useRouter } from "next/router";
import { useEffect } from "react";

let effectsRanBy: Record<string, boolean> = {};

const onRouteChangeComplete = () => {
    effectsRanBy = {};
};

// this key is expected to be unique as hard coded
export const useMountEffect = (callback: () => void, key: string) => {
    const router = useRouter();

    useEffect(() => {
        if (effectsRanBy[key]) return;
        effectsRanBy[key] = true;
        return callback();
    }, []);

    useEffect(() => {
        router.events.on("routeChangeComplete", onRouteChangeComplete);
        return () => router.events.off("routeChangeComplete", onRouteChangeComplete)
    }, []);
};